<script lang="ts">
  import { copy_room_id } from "../helpers";
  import { selected_game } from "../stores";

  export let spectating: boolean;
  export let spectators: number;
  export let room_id: string;
  export let leave_game: Function;
</script>

<div class="above">
  <h2 class="id">
    {#if spectating}
      you are spectating
    {:else}
      room: <b
        on:click={() => {
          copy_room_id($selected_game, room_id);
        }}
        class="room_id">{room_id}</b
      >
    {/if}
  </h2>
  <div class="topper">
    <h2
      class="back b"
      on:click={() => {
        leave_game();
      }}
    >
      <i class="fas fa-arrow-left" />
    </h2>

    <h2 class="right">
      {spectators} <i class="fas fa-eye" />
      &nbsp;&nbsp;

      <slot class="button" />
    </h2>
  </div>
</div>

<style>
  .topper {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 10px;
    margin-bottom: 5px;
  }

  .id {
    margin-bottom: 0.2rem;
    margin-top: 0.1rem;
    font-size: 1rem;
    color: rgb(173, 173, 173);
  }

  .back {
    margin: 0rem 0.8rem;
    font-size: 1.2rem;
    transition: all 100ms;
    cursor: pointer;
    user-select: none;
  }

  .right {
    margin: 0rem 0.8rem;
    font-size: 1.2rem;
    transition: all 100ms;
    cursor: pointer;
    user-select: none;
  }

  .button:hover {
    color: var(--text-color-hover);
  }

  .button:active {
    color: var(--text-color-active);
  }
  /* .b {
    margin-right: 1.5rem;
  } */

  .back:hover {
    color: var(--text-color-hover);
  }

  .back:active {
    color: var(--text-color-active);
  }

  .room_id {
    cursor: pointer;
    transition: all 100ms;
  }

  .room_id:hover {
    color: var(--text-color-hover);
  }

  .room_id:active {
    color: var(--text-color-active);
  }

  .id b {
    color: var(--text-color-secondary);
  }
</style>
